import React, { useState, useEffect, useRef } from "react";
import "./App.css";
import logo from "./Images/Final Monaj Logo.png";

// ─── PARTICLE CANVAS ─────────────────────────────────────────
const ParticleField = () => {
  const canvasRef = useRef(null);
  useEffect(() => {
    const canvas = canvasRef.current;
    if (!canvas) return;
    const ctx = canvas.getContext("2d");
    let animId;
    const resize = () => {
      canvas.width = window.innerWidth;
      canvas.height = window.innerHeight;
    };
    resize();
    window.addEventListener("resize", resize);
    const particles = Array.from({ length: 50 }, () => ({
      x: Math.random() * window.innerWidth,
      y: Math.random() * window.innerHeight,
      r: Math.random() * 1.3 + 0.3,
      dx: (Math.random() - 0.5) * 0.16,
      dy: (Math.random() - 0.5) * 0.16,
      alpha: Math.random() * 0.5 + 0.1,
      pulse: Math.random() * Math.PI * 2,
    }));
    const draw = () => {
      ctx.clearRect(0, 0, canvas.width, canvas.height);
      particles.forEach((p) => {
        p.x += p.dx;
        p.y += p.dy;
        p.pulse += 0.011;
        if (p.x < 0 || p.x > canvas.width) p.dx *= -1;
        if (p.y < 0 || p.y > canvas.height) p.dy *= -1;
        const a = p.alpha * (0.6 + 0.4 * Math.sin(p.pulse));
        ctx.beginPath();
        ctx.arc(p.x, p.y, p.r, 0, Math.PI * 2);
        ctx.fillStyle = `rgba(201,169,110,${a})`;
        ctx.fill();
      });
      animId = requestAnimationFrame(draw);
    };
    draw();
    return () => {
      cancelAnimationFrame(animId);
      window.removeEventListener("resize", resize);
    };
  }, []);
  return <canvas ref={canvasRef} className="particle-canvas" />;
};

// ─── SCROLL REVEAL WRAPPER ────────────────────────────────────
const FadeIn = ({ children, delay = 0, className = "" }) => {
  const ref = useRef(null);
  const [vis, setVis] = useState(false);
  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    const obs = new IntersectionObserver(
      ([e]) => { if (e.isIntersecting) setVis(true); },
      { threshold: 0.12, rootMargin: "0px 0px -50px 0px" }
    );
    obs.observe(el);
    return () => obs.disconnect();
  }, []);
  return (
    <div
      ref={ref}
      className={`fade-in ${vis ? "fade-in--visible" : ""} ${className}`}
      style={{ transitionDelay: `${delay}s` }}
    >
      {children}
    </div>
  );
};

// ─── PRODUCTS DATA ────────────────────────────────────────────
const PRODUCTS = [
  {
    name: "Epidermal Growth Factors Wonder Repair Serum",
    sub: "Youth Activating Concentrate",
    price: "£50",
    desc: "Epidermal Growth Factors utilizing a patented oleosome-growth factor fusion technology to act as carriers, ensuring the growth factor penetrates deeper into the dermis.",
    ingredients: [
      { name: "Epidermal Growth Factors", benefit: "Accelerates cell renewal and boosts collagen production to visibly reduce wrinkles, and firm the skin" },
      { name: "Fibroblast Growth Factor", benefit: "Targets hyperpigmentation (dark spots) and restores the skin barrier" },
      { name: "Niacinamide 5%",           benefit: "Calms redness, evens skin tone, and reinforses the skin barrier" },
      { name: "Centella Asiatica",        benefit: "Calms inflammation, reinforces barrier" },
      { name: "Aloe Vera",                benefit: "Provides deep, lightweight hydration while soothing and healing irritation" },
      { name: "Licorice Root",             benefit: "Reduces hyperpigmentation, and soothes inflammation for a more even, glowing complexion" },
    ],
  },
  {
    name: "Epidermal Growth Factors Wonder Repair Moisturiser",
    sub: "Dewy Nourishing anti-ageing Cream",
    price: "£50",
    desc: "A sumptuous cream that wraps sensitive skin in a protective veil of nature's finest emollients, with Epidermal Growth Factors utilizing a patented oleosome-growth factor fusion technology.",
    ingredients: [
      { name: "Epidermal Growth Factors", benefit: "Accelerates cell renewal and boosts collagen production to visibly reduce wrinkles, and firm the skin" },
      { name: "Ceramides",                benefit: "Replenishes the skin's natural lipid barrier to seal in moisture" },
      { name: "Polyglutamic acid",        benefit: "Holds up to 4x more moisture than Hyaloronic Acid and forms a film that prevents water evaporation" },
      { name: "Squalane",                 benefit: "Mirrors skin's own oils — zero greasiness" },
      { name: "Aloe Vera",                benefit: "Provides deep, lightweight hydration while soothing and healing irritation" },
      
    ],
  },
];

// ─── PRODUCT CARD ─────────────────────────────────────────────
const ProductCard = ({ product, index }) => {
  const [hoveredIng, setHoveredIng] = useState(null);
  const [preorderSent, setPreorderSent] = useState(false);

  const handlePreorder = () => {
    setPreorderSent(true);
    setTimeout(() => setPreorderSent(false), 2500);
  };

  return (
    <FadeIn delay={index * 0.15} className="product-card">
      <div className="product-card__badge">Coming Soon</div>
      <h3 className="product-card__name">{product.name}</h3>
      <p className="product-card__sub">{product.sub}</p>
      <p className="product-card__desc">{product.desc}</p>

      <p className="product-card__ing-label">Key Ingredients</p>
      <div className="product-card__ingredients">
        {product.ingredients.map((ing, i) => (
          <div
            key={i}
            className={`ingredient-row ${hoveredIng === i ? "ingredient-row--active" : ""}`}
            onMouseEnter={() => setHoveredIng(i)}
            onMouseLeave={() => setHoveredIng(null)}
          >
            <span className="ingredient-row__name">{ing.name}</span>
            <span className="ingredient-row__benefit">{ing.benefit}</span>
          </div>
        ))}
      </div>

      <div className="product-card__footer">
        <span className="product-card__price">{product.price}</span>
        <button
          className={`btn-preorder ${preorderSent ? "btn-preorder--sent" : ""}`}
          onClick={handlePreorder}
        >
          {preorderSent ? "✓ Noted!" : "Pre-Order Available Soon!"}
        </button>
      </div>
    </FadeIn>
  );
};

// ─── MAIN APP ─────────────────────────────────────────────────
function App() {
  const [navActive, setNavActive] = useState(false);
  const [scrolled, setScrolled]   = useState(false);
  const [formSent, setFormSent]   = useState(false);
  const [formData, setFormData]   = useState({ name: "", email: "", message: "" });

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 50);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const toggleNav = () => setNavActive((v) => !v);
  const closeNav  = () => setNavActive(false);

  const handleFormChange = (e) =>
    setFormData((f) => ({ ...f, [e.target.name]: e.target.value }));

  const handleFormSubmit = (e) => {
    e.preventDefault();
    const subject = encodeURIComponent("Monaj Enquiry from " + formData.name);
    const body    = encodeURIComponent(formData.message + "\n\nFrom: " + formData.email);
    window.location.href = `mailto:hello@monaj.co.uk?subject=${subject}&body=${body}`;
    setFormSent(true);
    setTimeout(() => setFormSent(false), 3000);
  };

  return (
    <div className="App">

      {/* ── HEADER ────────────────────────────────────────── */}
      <header className={`header ${scrolled ? "header--scrolled" : ""}`}>
        <img src={logo} alt="Monaj Logo" className="logo" />

        {/* Absolutely centred title — unaffected by logo or nav width */}
        <h1 className="hero-title header-title">Monaj</h1>

        <nav className={`nav ${navActive ? "active" : ""}`}>
          <a href="#home"     onClick={closeNav}>Home</a>
          <a href="#products" onClick={closeNav}>Products</a>
          <a href="#about"    onClick={closeNav}>Our Story</a>
          <a href="#contact"  onClick={closeNav}>Contact</a>
        </nav>

        <button
          className="hamburger"
          onClick={toggleNav}
          aria-label="Toggle navigation"
        >
          {navActive ? "✕" : "☰"}
        </button>
      </header>

      {/* ── HERO ──────────────────────────────────────────── */}
      <section id="home" className="hero">
        <ParticleField />

        {/* Atmospheric glows */}
        <div className="hero__glow hero__glow--burgundy" />
        <div className="hero__glow hero__glow--gold" />

        <div className="hero__content">

          {/* Floating logo emblem */}
          <div className="hero__logo-wrap">
            <img src={logo} alt="Monaj" className="hero__logo-emblem" />
          </div>

          {/* Pre-launch badge */}
          <div className="hero__pre-badge">
            <span className="hero__pre-line" />
            <span className="hero__pre-text">Accepting Pre-Orders Soon</span>
            <span className="hero__pre-line" />
          </div>

          {/* Main headline */}
          <h2 className="hero__headline">
            Skin Sensitive Focused<br />
            <em className="hero__headline--gold">Science Led Beauty.</em>
          </h2>

          <p className="hero__sub">
            Clinically crafted for sensitive skin.<br />
            Worn with the confidence of luxury.
          </p>

          {/* CTA buttons */}
          <div className="hero__ctas">
            <a href="#products" className="btn-primary">Discover the Collection</a>
            <a href="#about"    className="btn-secondary">Our Philosophy</a>
          </div>

          {/* Scroll indicator */}
          <div className="hero__scroll-hint">
            <span className="hero__scroll-text">Scroll</span>
            <span className="hero__scroll-line" />
          </div>

        </div>
      </section>

      {/* ── CREDENTIAL STRIP ──────────────────────────────── */}
      <div className="strip">
        {["Sensitive-First Formula","Clinically Tested","Fragrance Free","Cruelty Free & Vegan","British Luxury"].map((t, i, a) => (
          <React.Fragment key={t}>
            <span className="strip__item">{t}</span>
            {i < a.length - 1 && <span className="strip__divider">✦</span>}
          </React.Fragment>
        ))}
      </div>

      {/* ── PRODUCTS ──────────────────────────────────────── */}
      <section id="products" className="section-products">
        <FadeIn>
          <p className="section-eyebrow">The Edit</p>
          <h2 className="section-title">
            Two Rituals.<br />
            <em className="gold-cursive">Infinite Results.</em>
          </h2>
          <p className="section-subtitle">
            Hover over each ingredient to discover the story behind every choice.
          </p>
        </FadeIn>

        <div className="products-grid">
          {PRODUCTS.map((p, i) => (
            <ProductCard key={p.name} product={p} index={i} />
          ))}
        </div>
      </section>

      {/* ── MANIFESTO ─────────────────────────────────────── */}
      <div className="manifesto">
        <FadeIn>
          <span className="manifesto__ornament">✦ The Monaj Manifesto ✦</span>
          <blockquote className="manifesto__quote">
            "Sensitive skin is not a limitation —<br />
            <em>it is simply skin that deserves to be listened to.</em>"
          </blockquote>
        </FadeIn>
      </div>

      {/* ── ABOUT ─────────────────────────────────────────── */}
      <section id="about" className="section-about">
        <FadeIn>
          <p className="section-eyebrow">Our Story</p>
          <h2 className="section-title">
            Born from Frustration.<br />
            <em className="gold-cursive">Refined by Science.</em>
          </h2>
          <p className="about__body">
            Monaj was founded on a quiet belief: that sensitive skin deserves more
            than clinical white tubes and sterile promises. It deserves the warmth
            of luxury — the ritual, the elegance, the confidence.
          </p>
          <p className="about__body">
            We spent years at the intersection of clinical dermatology and
            high-end formulation, sourcing only ingredients that perform without
            provoking. The result is a brand that feels like a gift to yourself.
          </p>
          <div className="about__stats">
            {[["100%","Fragrance Free"],["0","Irritants or Fillers"],["2","Debut Products"]].map(([n, l]) => (
              <div key={l} className="about__stat">
                <span className="about__stat-num">{n}</span>
                <span className="about__stat-label">{l}</span>
              </div>
            ))}
          </div>
        </FadeIn>
      </section>

      {/* ── CONTACT ───────────────────────────────────────── */}
      <section id="contact" className="section-contact">
        <FadeIn>
          <p className="section-eyebrow">Get in Touch</p>
          <h2 className="section-title">
            We'd Love to Hear<br />
            <em className="gold-cursive">From You</em>
          </h2>
          <p className="section-subtitle">
            For pre-orders, press enquiries, or partnerships
          </p>

          <form className="contact-form" onSubmit={handleFormSubmit}>
            <div className="contact-form__group">
              <label className="contact-form__label">Your Name</label>
              <input
                className="contact-form__input"
                type="text"
                name="name"
                placeholder="Full Name"
                value={formData.name}
                onChange={handleFormChange}
                required
              />
            </div>
            <div className="contact-form__group">
              <label className="contact-form__label">Email Address</label>
              <input
                className="contact-form__input"
                type="email"
                name="email"
                placeholder="your@email.com"
                value={formData.email}
                onChange={handleFormChange}
                required
              />
            </div>
            <div className="contact-form__group">
              <label className="contact-form__label">Message</label>
              <textarea
                className="contact-form__input contact-form__textarea"
                name="message"
                placeholder="Tell us anything..."
                rows={5}
                value={formData.message}
                onChange={handleFormChange}
                required
              />
            </div>
            <button type="submit" className="btn-primary btn-primary--full">
              {formSent ? "✓ Message Sent!" : "Send Message"}
            </button>
          </form>
        </FadeIn>
      </section>

      {/* ── FOOTER ────────────────────────────────────────── */}
      <footer className="footer">
        <img src={logo} alt="Monaj" className="footer__logo" />
        <h1 className="hero-title footer__title">Monaj</h1>
        <p className="footer__copy">© 2025 Monaj London. All rights reserved.</p>
        <div className="footer__links">
          <a href="#home">Privacy Policy</a>
          <span>·</span>
          <a href="#home">Terms</a>
          <span>·</span>
          <a href="#home">Sustainability</a>
        </div>
      </footer>

    </div>
  );
}

export default App;